import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

/**
 * services/tokens/providers
*/
import { EXPORTERS } from './exporters.token';
import { ExportFacadeService } from '../facade';
import { EXPORT_OPTIONS } from './export-options.token';
import { EXPORT_BRANDING } from './export-branding.token';
import { CsvExporterService, ExcelExporterService, ImageExporterService, PdfExporterService } from '../strategies';
import { EXPORT_BRANDING_DEFAULT_OPTIONS, IExportBrandingOptions } from './export-branding';
import { EXPORT_PROVIDER_DEFAULT_OPTIONS, IExportProviderOptions } from './export-provider-options';

/**
 * Registers export defaults at app/feature/component provider level.
 * Also registers all exporter strategies and the export facade.
 *
 * @param options - Lightweight global defaults.
 * @param branding - Document chrome applied to generated files.
 * @returns The providers to register.
 */
export function provideExport(
  options: Partial<IExportProviderOptions> = {},
  branding: Partial<IExportBrandingOptions> = {},
): EnvironmentProviders {

  // Merge the default options with the provided options
  const mergedOptions: IExportProviderOptions = {
    ...EXPORT_PROVIDER_DEFAULT_OPTIONS,
    ...options,
  };

  // Merge the default branding with the provided branding
  const mergedBranding: IExportBrandingOptions = {
    ...EXPORT_BRANDING_DEFAULT_OPTIONS,
    ...branding,
  };

  return makeEnvironmentProviders([
    ExportFacadeService,
    CsvExporterService,
    ExcelExporterService,
    PdfExporterService,
    ImageExporterService,
    {
      provide: EXPORT_OPTIONS,
      useValue: mergedOptions,
    },
    {
      provide: EXPORT_BRANDING,
      useValue: mergedBranding,
    },
    {
      provide: EXPORTERS,
      useExisting: CsvExporterService,
      multi: true,
    },
    {
      provide: EXPORTERS,
      useExisting: ExcelExporterService,
      multi: true,
    },
    {
      provide: EXPORTERS,
      useExisting: PdfExporterService,
      multi: true,
    },
    {
      provide: EXPORTERS,
      useExisting: ImageExporterService,
      multi: true,
    },
  ]);
}
